import merge from 'lodash/merge';
import { env } from '@repo/env';
import { createFetcher } from './fetcher';
var getFetcherDefaultOptions = function () {
    return {
        baseUrl: env.VITE_API_URL || '',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    };
};
var ApiClient = /** @class */ (function () {
    function ApiClient() {
        this._fetch = createFetcher(getFetcherDefaultOptions());
    }
    Object.defineProperty(ApiClient, "fetch", {
        get: function () {
            return ApiClient.getInstance()._fetch;
        },
        enumerable: false,
        configurable: true
    });
    ApiClient.getInstance = function () {
        //TS infers that it is a falsy value, but it's initialized indeed. It's proved in tests see api-client.test.ts
        if (!ApiClient.instance) {
            return (ApiClient.instance = new ApiClient());
        }
        return ApiClient.instance;
    };
    ApiClient.resetOptions = function () {
        var instance = ApiClient.getInstance();
        instance._fetch = createFetcher(getFetcherDefaultOptions());
    };
    ApiClient.updateFetcher = function (options) {
        var instance = ApiClient.getInstance();
        instance._fetch = createFetcher({
            baseUrl: getFetcherDefaultOptions().baseUrl,
            options: merge(getFetcherDefaultOptions().options, options),
        });
    };
    return ApiClient;
}());
export { ApiClient };
